import React, {useEffect, useRef} from 'react';
import {Button} from "@mui/material";
import {MarkEmailReadOutlined} from '@mui/icons-material';
import classes from "./CheckMailInbox.module.scss"

const CheckMailInbox = ({email, onContinue}: {email?: string; onContinue: () => void}) => {
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => {heading.current?.focus();}, []);
  return (
    <div className={classes['check-mail-inbox']}>
      <section className={classes.card} aria-labelledby="check-email-title">
        <span className={classes.icon}><MarkEmailReadOutlined aria-hidden="true"/></span>
        <h1 id="check-email-title" ref={heading} tabIndex={-1}>Check your email</h1>
        <p>We sent a confirmation email{email ? <> to <strong>{email}</strong></> : ' to your email address'}.</p>
        <p>Open the link in that email to confirm your account, then sign in.</p>
        <p className={classes.help}>Can’t find it? Check your spam or junk folder.</p>
        <Button variant="contained" fullWidth onClick={onContinue}>Continue to login</Button>
      </section>
    </div>

  );
};

export default CheckMailInbox;
